module.exports = "/components/components/rectangleIconButton-31f55c.html";